import { useContext, useState } from "react";
import { AlertContext } from "Hooks/AlertContext";
import Loader from "elements/Loader";
import { forceForeverSaves_api } from "api/fanApi";
import useBrand from "Hooks/useBrand";
import ButtonSymphony from "elements/ButtonSymphony";
import RecordSearchView from "elements/RecordSearchView";
import ModalSymphony from "elements/ModalSymphony";
import { BrandContent, RecordDetails } from "modules/Types";
import CardSymphony from "elements/CardSymphony";
import useScreen from "Hooks/useScreen";

const AdminContainerForceForeverSaves = () => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <CardSymphony
            className="adminContainerForceForeverSavesComponent"
            style={{ gap: 0 }}
        >
            <CardSymphony
                className="headerForAdminPresaves"
                title="Admin"
                isNoPadding
                size="small"
            />
            <ButtonSymphony
                className="AdminContainerForceForeverSaves-Button"
                variant="text"
                onClick={() => setOpenModal(true)}
            >
                Run Forever Saves Manually
            </ButtonSymphony>
            <ForceForeverSavesRecordSelector
                closeModal={() => setOpenModal(false)}
                open={openModal}
            />
        </CardSymphony>
    );
};

interface ForceForeverSavesRecordSelectorProps {
    closeModal: () => void;
    open: boolean;
}

const ForceForeverSavesRecordSelector = ({
    closeModal,
    open,
}: ForceForeverSavesRecordSelectorProps) => {
    const { cssCalc } = useScreen();
    const { showSnackbar } = useContext(AlertContext);
    const { currentBrand } = useBrand();

    const [loading, setLoading] = useState(false);

    const handleSelectRecord = async (recordDetails: RecordDetails) => {
        const { slug } = recordDetails;
        if (!slug) {
            return;
        }

        setLoading(true);

        try {
            await forceForeverSaves_api(slug, currentBrand?.slug || "");
            showSnackbar("Job added to queue", {
                severity: "success",
            });
            closeModal();
        } catch (error) {
            console.error("🚦 ~ handleChangeRecord ~ error:", error);
            showSnackbar("Error adding job to queue, check logs", {
                severity: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    if (!currentBrand) {
        return null
    }

    return (
        <ModalSymphony isOpen={open} onClose={closeModal} className="ForceForeverSavesRecordSelector-Modal"
            title="ADMIN: Run Forever Saves Manually"
            subtitle="Select a record to force forever fan saves"
        >
            <>
                {loading ? (
                    <Loader />
                ) : (
                    <RecordSearchView
                        handleSelectRecord={handleSelectRecord}
                        options={["single", "project"]}
                        maxHeight={cssCalc(320)}
                    />
                )}
            </>
        </ModalSymphony>
    );
};

export default AdminContainerForceForeverSaves;